import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';

type DotLoaderSizeType = 'small' | 'mid';

@Component({
    selector: 'fi-dot-loader',
    template: `
        <div class="animation_dot"></div>
        <div class="animation_dot"></div>
        <div class="animation_dot"></div>
    `,
    styleUrl: 'fi-dot-loader.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-dot-loader' },
    standalone: false,
})
export class FiDotLoaderComponent {
    @Input() loaderSize: DotLoaderSizeType = 'mid';
    @HostBinding('class')
    get hostClasses(): string {
        return `loader-${this.loaderSize}`;
    }
}
